<template>
  <div class="__PreferencesDialogChart">
    <CSection margin-bottom="2rem">
      <CRow gutter="md">
        <!--<CCol col="12" sm="6">-->
        <!--  <CSelector-->
        <!--    :label="$t('Cost type')"-->
        <!--    v-model="currentCostType"-->
        <!--    :options="costTypeOptions"-->
        <!--    :use-input="false"-->
        <!--    emit-value-->
        <!--    map-options-->
        <!--  />-->
        <!--</CCol>-->

        <!--<CCol col="12" sm="6">-->
        <!--  <CSelector-->
        <!--    :label="$t('Currency')"-->
        <!--    v-model="currentCurrency"-->
        <!--    :options="currencyOptions"-->
        <!--    :use-input="false"-->
        <!--    emit-value-->
        <!--    map-options-->
        <!--  />-->
        <!--</CCol>-->
      </CRow>
    </CSection>

    <CSection margin-bottom="2rem">
      <CRow gutter="md">
        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Default date range')"
            v-model="currentDefaultRange"
            :options="defaultRangeOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Default granularity')"
            v-model="currentDefaultGranularity"
            :options="defaultGranularityOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <!--<CCol col="12" sm="6">-->
        <!--  <CSelector-->
        <!--    :label="$t('Default group by')"-->
        <!--    v-model="currentDefaultCategory"-->
        <!--    :options="categoryOptions"-->
        <!--    :use-input="false"-->
        <!--    emit-value-->
        <!--    map-options-->
        <!--  />-->
        <!--</CCol>-->

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Default chart type')"
            v-model="currentDefaultChartType"
            :options="defaultChartTypeOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Default table item display count')"
            v-model="currentDefaultTableRecordsPerPage"
            :options="defaultTableRecordsPerPageOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>
      </CRow>
    </CSection>

    <CSection margin-bottom="2rem">
      <CRow gutter="md">
        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Total chart style')"
            v-model="currentTotalStrokeType"
            :options="totalStrokeTypeOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Line width of total chart')"
            v-model="currentTotalLineWidth"
            :options="totalLineWidthOptions"
            :use-input="false"
            emit-value
            map-options
          />
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Total chart color')"
            v-model="currentTotalColor"
            :options="colorOptions"
            :use-input="false"
            emit-value
            map-options
          >
            <template v-slot:option="{ scope }">
              <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                <q-item-section avatar>
                  <q-icon name="circle" :style="`color: ${scope.opt.value}`" />
                </q-item-section>
                <q-item-section>
                  <q-item-label v-html="scope.opt.label" />
                </q-item-section>
              </q-item>
            </template>
          </CSelector>
        </CCol>
      </CRow>
    </CSection>

    <CSection margin-bottom="2rem">
      <CRow gutter="md">
        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Maximum number of series to display')"
            v-model="currentNonGroupingSeriesCount"
            :options="nonGroupingSeriesCountOptions"
            :use-input="false"
            :error-message="
              currentNonGroupingSeriesCount === 200
                ? $t('Browser may crash if there is a lot of data')
                : undefined
            "
          >
            <template slot="post-label">
              <HelpPopover placement="bottom">{{
                $t(
                  'This shows the maximum number of distinct services that will be shown in the graph and table when filtering. Any services selected over this value will be grouped into "Other".'
                )
              }}</HelpPopover>
            </template>
          </CSelector>
        </CCol>

        <CCol col="12" sm="6">
          <CSelector
            :label="$t('Others chart color')"
            v-model="currentOthersColor"
            :options="colorOptions"
            :use-input="false"
            emit-value
            map-options
          >
            <template v-slot:option="{ scope }">
              <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                <q-item-section avatar>
                  <q-icon name="circle" :style="`color: ${scope.opt.value}`" />
                </q-item-section>
                <q-item-section>
                  <q-item-label v-html="scope.opt.label" />
                </q-item-section>
              </q-item>
            </template>
          </CSelector>
        </CCol>
      </CRow>
    </CSection>

    <CSection>
      <CRow gutter="md" items-center>
        <!--<CCol col="12" sm="6">-->
        <!--  <CItem tag="label">-->
        <!--    <CItemSection avatar>-->
        <!--      <CCheckBox v-model="currentAnimation" />-->
        <!--    </CItemSection>-->
        <!--    <CItemSection>-->
        <!--      <CItemLabel>-->
        <!--        {{ $t('Animation') }}-->
        <!--      </CItemLabel>-->
        <!--      <CItemLabel caption>-->
        <!--        {{ $t('Turning off animation may improve performance.') }}-->
        <!--      </CItemLabel>-->
        <!--    </CItemSection>-->
        <!--  </CItem>-->
        <!--</CCol>-->

        <CCol col="12" sm="6">
          <CItem tag="label">
            <CItemSection avatar>
              <CCheckBox v-model="currentGrouping" />
            </CItemSection>
            <CItemSection>
              <CItemLabel>
                {{ $t('Data grouping') }}
              </CItemLabel>
              <CItemLabel caption>
                {{
                  $t(
                    'Group the data displayed on the chart. Turning it on may improve performance.'
                  )
                }}
              </CItemLabel>
            </CItemSection>
          </CItem>
        </CCol>

        <CCol col="12" sm="6">
          <CItem tag="label">
            <CItemSection avatar>
              <CCheckBox v-model="currentScrollbar" />
            </CItemSection>
            <CItemSection>
              <CItemLabel>
                {{ $t('Display map') }}
              </CItemLabel>
              <CItemLabel caption>
                {{ $t('Display the entire map at the bottom of the chart.') }}
              </CItemLabel>
            </CItemSection>
          </CItem>
        </CCol>
      </CRow>
    </CSection>
  </div>
</template>

<script>
import Vue from 'vue';

// Chart lib
import chartColors from '@/components/CustomCharts/colors';
// Chart common lang
import chartLang from '@/components/CustomCharts/lang';

import CRow from '@/components/uikit/CRow';
import CCol from '@/components/uikit/CCol';
import CTitle from '@/components/uikit/CTitle';
import CSection from '@/components/uikit/CSection';
import CCheckBox from '@/components/uikit/CCheckBox';
import CSelector from '@/components/uikit/CSelector';
import CInputNumber from '@/components/uikit/CInputNumber';
import CItem from '@/components/uikit/CItem';
import CItemSection from '@/components/uikit/CItemSection';
import CItemLabel from '@/components/uikit/CItemLabel';
import HelpPopover from '@/components/uikit/HelpPopover';

const messages = {
  en: {
    // Chart common lang
    ...chartLang.en,

    'Cost type': 'Cost type',
    Currency: 'Currency',
    'Default date range': 'Date range',
    'Default granularity': 'Granularity',
    'Default group by': 'Default group by',
    'Default chart type': 'Chart Type',
    'Default table item display count': 'Table Page Size',
    'Total chart style': 'Chart Style',
    'Line width of total chart': 'Chart Line Thickness',
    'Total chart color': 'Chart Line Color',
    'Maximum number of series to display': 'Number of Distinct Services',
    'Others chart color': 'Other Bar Color',
    Animation: 'Animation',
    'Turning off animation may improve performance.':
      'Turning off animation may improve performance.',
    'Data grouping': 'Group Data By Week',
    'Group the data displayed on the chart. Turning it on may improve performance.':
      'Group the chart data by week. Turning this setting on may improve performance for long query periods.',
    'Display map': 'Display Data Map',
    'Display the entire map at the bottom of the chart.':
      'Display the data beneath the main chart.',
    All: 'All',
    'Browser may crash if there is a lot of data': 'Browser may crash if there is a lot of data',
    'This shows the maximum number of distinct services that will be shown in the graph and table when filtering. Any services selected over this value will be grouped into "Other".':
      'This shows the maximum number of distinct services that will be shown in the graph and table when filtering. Any services selected over this value will be grouped into "Other".',
  },
  ja: {
    // Chart common lang
    ...chartLang.ja,

    'Cost type': 'コストタイプ',
    Currency: '通貨タイプ',
    'Default date range': 'デフォルトの期間',
    'Default granularity': 'デフォルトの時間粒度',
    'Default group by': 'デフォルトのグループカテゴリ',
    'Default chart type': 'デフォルトのチャートタイプ',
    'Default table item display count': 'デフォルトのテーブルアイテム表示数',
    'Total chart style': '合計チャートのスタイル',
    'Line width of total chart': '合計チャートのライン線幅',
    'Total chart color': '合計チャートのカラー',
    'Maximum number of series to display': 'シリーズの最大表示数',
    'Others chart color': 'その他チャートのカラー',
    Animation: 'アニメーション',
    'Turning off animation may improve performance.':
      'アニメーションをオフにするとパフォーマンスが改善される場合があります。',
    'Data grouping': 'データのグルーピング',
    'Group the data displayed on the chart. Turning it on may improve performance.':
      'チャートに表示されるデータをグループ化します。オンにするとパフォーマンスが改善される場合があります。',
    'Display map': 'マップを表示',
    'Display the entire map at the bottom of the chart.':
      'チャートの下部に全体マップを表示します。',
    All: 'すべて',
    'Browser may crash if there is a lot of data':
      'データ量が多い場合ブラウザがクラッシュする可能性があります',
    'This shows the maximum number of distinct services that will be shown in the graph and table when filtering. Any services selected over this value will be grouped into "Other".':
      'フィルタリング時にグラフと表に表示される個別のサービスの最大数を示しています。 最大数を超えたサービスはすべて「その他」にグループ化されます。',
  },
};

export default Vue.extend({
  name: 'PreferencesDialogChart',
  i18n: { messages, chartLang },
  components: {
    CRow,
    CCol,
    CTitle,
    CSection,
    CCheckBox,
    CSelector,
    CInputNumber,
    HelpPopover,
    CItem,
    CItemSection,
    CItemLabel,
  },
  props: {
    costType: {
      type: String,
    },
    currency: {
      type: String,
    },
    defaultChartType: {
      type: String,
    },
    defaultCategory: {
      type: String,
    },
    defaultGranularity: {
      type: String,
    },
    defaultRange: {
      type: String,
    },
    defaultTableRecordsPerPage: {
      type: Number,
    },
    totalStrokeType: {
      type: String,
    },
    totalLineWidth: {
      type: Number,
    },
    totalColor: {
      type: String,
    },
    nonGroupingSeriesCount: {
      type: Number,
    },
    othersColor: {
      type: String,
    },
    animation: {
      type: Boolean,
    },
    grouping: {
      type: Boolean,
    },
    scrollbar: {
      type: Boolean,
    },
    categoryOptions: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  watch: {
    currentDefaultGranularity(val) {
      // Case: daily
      // APIがデータレンジ2ヶ月間しかサポートしていないため
      // 2ヶ月以上のレンジの場合は自動でMTDに変更する。
      if (val === 'daily') {
        if (this.currentDefaultRange !== 'mtd' && this.currentDefaultRange !== 'lastMonth') {
          this.currentDefaultRange = 'mtd';
        }
      }
    },
  },
  data() {
    return {
      defaultGranularityOptions: [
        { label: this.$t('Daily'), value: 'daily' },
        { label: this.$t('Monthly'), value: 'monthly' },
      ],

      defaultChartTypeOptions: [
        { label: this.$t('Stacked'), value: 'stacked' },
        { label: this.$t('Bar'), value: 'bar' },
        { label: this.$t('Line'), value: 'line' },
      ],

      /*
       * Total series
       */
      totalStrokeTypeOptions: [
        { label: this.$t('Solid'), value: 'solid' },
        { label: this.$t('Solid with bullet'), value: 'solid-bullet' },
        { label: this.$t('Dashed'), value: 'dashed' },
        { label: this.$t('Dashed with bullet'), value: 'dashed-bullet' },
      ],

      totalLineWidthOptions: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
      ],

      /*
       * Others series
       */
      nonGroupingSeriesCountOptions: [5, 10, 15, 20, 200],

      /*
       * Datatable
       */
      defaultTableRecordsPerPageOptions: [
        { label: this.$t('10'), value: 10 },
        { label: this.$t('30'), value: 30 },
        { label: this.$t('50'), value: 50 },
        { label: this.$t('100'), value: 100 },
        { label: this.$t('All'), value: 'all' },
      ],

      currencyOptions: [
        { label: this.$t('USD'), value: 'usd' },
        //{ label: this.$t('JPY'), value: 'jpy' },
      ],

      costTypeOptions: [
        { label: 'True Unblended', value: 'true_unblended_cost' },
        { label: 'Unblended', value: 'unblended_cost' },
        { label: 'blended', value: 'blended_cost' },
      ],
    };
  },
  computed: {
    defaultRangeOptions() {
      if (this.currentDefaultGranularity === 'daily') {
        return [
          { label: this.$t('Month to date'), value: 'mtd' },
          { label: this.$t('Last month'), value: 'lastMonth' },
        ];
      }

      return [
        { label: this.$t('Month to date'), value: 'mtd' },
        { label: this.$t('Last month'), value: 'lastMonth' },
        { label: this.$t('Year to date'), value: 'ytd' },
        //{ label: this.$t('Last 7 days'), value: '7days' },
        //{ label: this.$t('Last 14 days'), value: '14days' },
        //{ label: this.$t('Last 30 days'), value: '30days' },
        //{ label: this.$t('Last 90 days'), value: '90days' },
        //{ label: this.$t('Last 180 days'), value: '180days' },
        { label: this.$t('Last 3 months'), value: '3months' },
        { label: this.$t('Last 6 months'), value: '6months' },
        { label: this.$t('Last 1 year'), value: '1year' },
      ];
    },

    colorOptions() {
      return Object.entries(chartColors).map(([key, value]) => {
        return {
          label: this.$t(key),
          value: value,
        };
      });
    },

    currentCostType: {
      get() {
        return this.costType;
      },
      set(string) {
        this.$emit('update:costType', string);
      },
    },
    currentCurrency: {
      get() {
        return this.currency;
      },
      set(string) {
        this.$emit('update:currency', string);
      },
    },
    currentDefaultChartType: {
      get() {
        return this.defaultChartType;
      },
      set(string) {
        this.$emit('update:defaultChartType', string);
      },
    },
    currentDefaultCategory: {
      get() {
        return this.defaultCategory;
      },
      set(string) {
        this.$emit('update:defaultCategory', string);
      },
    },
    currentDefaultGranularity: {
      get() {
        return this.defaultGranularity;
      },
      set(string) {
        this.$emit('update:defaultGranularity', string);
      },
    },
    currentDefaultRange: {
      get() {
        return this.defaultRange;
      },
      set(string) {
        this.$emit('update:defaultRange', string);
      },
    },

    currentDefaultTableRecordsPerPage: {
      get() {
        return this.defaultTableRecordsPerPage;
      },
      set(number) {
        this.$emit('update:defaultTableRecordsPerPage', number);
      },
    },

    currentTotalStrokeType: {
      get() {
        return this.totalStrokeType;
      },
      set(string) {
        this.$emit('update:totalStrokeType', string);
      },
    },

    currentTotalLineWidth: {
      get() {
        return this.totalLineWidth;
      },
      set(string) {
        this.$emit('update:totalLineWidth', string);
      },
    },

    currentTotalColor: {
      get() {
        return this.totalColor;
      },
      set(string) {
        this.$emit('update:totalColor', string);
      },
    },

    currentNonGroupingSeriesCount: {
      get() {
        return this.nonGroupingSeriesCount;
      },
      set(string) {
        this.$emit('update:nonGroupingSeriesCount', string);
      },
    },

    currentOthersColor: {
      get() {
        return this.othersColor;
      },
      set(string) {
        this.$emit('update:othersColor', string);
      },
    },

    currentAnimation: {
      get() {
        return this.animation;
      },
      set(boolean) {
        this.$emit('update:animation', boolean);
      },
    },

    currentGrouping: {
      get() {
        return this.grouping;
      },
      set(boolean) {
        this.$emit('update:grouping', boolean);
      },
    },

    currentScrollbar: {
      get() {
        return this.scrollbar;
      },
      set(boolean) {
        this.$emit('update:scrollbar', boolean);
      },
    },
  },
});
</script>
